(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ozoric-bio-bridge"] && !Shopify.designMode) return;
  try {
    ;(async () => {
  const [{ StandardEvents }, { addNativeCartItems }] = await Promise.all([
    import('@shopify/events'),
    import('@theme/ozoric-cart-actions')
  ]);
if (!customElements.get('ozoric-bio-bridge')) {
    customElements.define('ozoric-bio-bridge', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.initialize(), {
            once: true,
            signal: this.abortController.signal
          });
        } else {
          queueMicrotask(() => this.initialize());
        }
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.priceObserver?.disconnect();
      }

      initialize() {
        if (!this.isConnected) return;
        this.section = this.closest('.shopify-section');
        this.source = this.parentElement.querySelector('.sg-leaf-page');
        if (!this.section || !this.source) return;
        try {
          this.data = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
        } catch {
          return;
        }
        this.variants = new Map(this.data.variants.map(variant => [variant.id, variant]));
        this.section.setAttribute('data-oz-bio-section', '');
        this.inputs = Array.from(this.source.querySelectorAll('.sg-offer-card input[type="radio"]'));
        if (!this.inputs.length) return;
        this.inputs.forEach(input => {
          input.name = `ozoric-bio-offer-${this.dataset.sectionId}`;
          const variant = this.variants.get(input.value);
          input.disabled = !variant?.available;
          input.closest('.sg-offer-card').setAttribute('aria-disabled', String(!variant?.available));
        });
        const nativePicker = this.nativePicker();
        if (nativePicker && this.inputs.every(input => this.variants.has(input.value))) {
          this.section.setAttribute('data-oz-bio-bundles-ready', '');
        }
        this.prepareLayout();
        this.refreshPrices();
        const requestedId = new URL(window.location.href).searchParams.get('variant');
        const selectedId = this.variants.has(requestedId) ? requestedId : this.data.selectedId;
        this.selectCard(selectedId);
        this.priceObserver?.disconnect();
        this.priceObserver = new MutationObserver(() => this.refreshSelectedPrice());
        this.priceObserver.observe(this.section, { subtree: true, childList: true });
        const signal = this.abortController.signal;
        this.source.addEventListener('change', event => {
          if (this.inputs.includes(event.target) && event.target.checked) {
            this.selectVariant(event.target.value);
          }
        }, { signal });
        this.section.addEventListener(StandardEvents.productSelect, event => {
          event.promise?.then(({ detail }) => {
            if (String(detail?.productId) !== this.dataset.productId) return;
            requestAnimationFrame(() => {
              this.syncForm(this.selectedId);
              this.refreshSelectedPrice();
            });
          }).catch(() => {});
        }, { signal });
        this.section.addEventListener('submit', event => {
          const form = this.nativeForm();
          if (event.target !== form || !this.selectedId) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.submitExactVariant(false);
        }, { capture: true, signal });
        this.section.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button) return;
          const component = button.closest('product-form-component');
          const isProductButton = component?.dataset.productId === this.dataset.productId;
          const isBuyNow = isProductButton && button.matches('.oz-buy-now__button');
          const isAddToCart = isProductButton && button.matches('[ref="addToCartButton"]');
          const isSticky = button.closest('sticky-add-to-cart')?.dataset.productId === this.dataset.productId;
          if (!isBuyNow && !isAddToCart && !isSticky) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          this.submitExactVariant(isBuyNow, button);
        }, { capture: true, signal });
        window.addEventListener('pageshow', event => {
          if (!event.persisted) return;
          this.posting = false;
          this.purchaseBusy = false;
          this.updatePurchaseState();
        }, { signal });
        this.section.querySelectorAll('.sg-cta').forEach(link => {
          link.addEventListener('click', event => {
            const target = this.inputs.find(input => input.checked) || this.inputs[0];
            if (!target) return;
            event.preventDefault();
            target.closest('.sg-offer-card').scrollIntoView({
              behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
              block: 'center'
            });
            target.focus({ preventScroll: true });
          }, { signal });
        });
      }

      nativePicker() {
        return this.section.querySelector(`variant-picker[data-product-id="${this.dataset.productId}"]`);
      }

      nativeForm() {
        return this.section.querySelector(`product-form-component[data-product-id="${this.dataset.productId}"] form`);
      }

      prepareLayout() {
        const oldForm = this.inputs[0]?.closest('form');
        if (oldForm && this.source.contains(oldForm)) {
          const offers = document.createElement('div');
          offers.className = 'oz-bio-offers';
          offers.append(...oldForm.childNodes);
          oldForm.replaceWith(offers);
        }
        const form = this.nativeForm();
        const buyButtons = form?.closest('.buy-buttons-block');
        const stock = this.source.querySelector('.sg-stock');
        if (buyButtons && stock && !this.source.contains(buyButtons)) stock.after(buyButtons);
        const secure = this.source.querySelector('.sg-secure');
        const supportBlocks = Array.from(this.section.querySelectorAll('.product-details .payment-icons, .product-details .oz-original-timeline, .product-details .oz-original-collapsible'));
        if (secure && supportBlocks.length) {
          let support = this.source.querySelector('.oz-bio-purchase-support');
          if (!support) {
            support = document.createElement('div');
            support.className = 'oz-bio-purchase-support';
            secure.after(support);
          }
          support.append(...supportBlocks);
        }
        const grid = this.section.querySelector('.product-information__grid');
        const panels = Array.from(this.source.querySelectorAll('.sg-trust, .sg-section'));
        if (grid && panels.length) {
          let wide = this.section.querySelector('.oz-bio-wide-content');
          if (!wide) {
            wide = document.createElement('div');
            wide.className = 'oz-bio-wide-content';
            grid.after(wide);
          }
          wide.append(...panels);
        }
      }

      refreshPrices() {
        this.inputs.forEach(input => {
          const variant = this.variants.get(input.value);
          const card = input.closest('.sg-offer-card');
          const price = card.querySelector('.sg-price');
          if (!variant || !price) return;
          price.replaceChildren(document.createTextNode(variant.priceText));
          if (variant.compareAtPrice > variant.price) {
            const compare = document.createElement('del');
            compare.textContent = variant.compareAtPriceText;
            price.append(compare);
          }
          const saving = card.querySelector('.sg-save');
          if (saving) {
            saving.hidden = variant.compareAtPrice <= variant.price;
            if (!saving.hidden) {
              const discount = Math.round((1 - variant.price / variant.compareAtPrice) * 100);
              saving.textContent = saving.textContent.replace(/\d+(?:[.,]\d+)?\s*%/, `${discount}%`);
            }
          }
        });
      }

      selectCard(id) {
        if (!this.variants.has(id)) return;
        this.selectedId = id;
        this.inputs.forEach(input => {
          input.checked = input.value === id;
          input.closest('.sg-offer-card').classList.toggle('is-selected', input.checked);
        });
        this.refreshSelectedPrice();
      }

      refreshSelectedPrice() {
        if (!this.isConnected) return;
        const variant = this.variants.get(this.selectedId);
        if (!variant) return;
        const containers = this.section.querySelectorAll('.oz-original-price, .sticky-add-to-cart__price');
        containers.forEach(container => {
          let row = container.querySelector(':scope > .oz-bio-price-row');
          if (!row) {
            row = document.createElement('div');
            row.className = 'oz-bio-price-row';
            row.setAttribute('aria-live', 'polite');
            row.setAttribute('aria-atomic', 'true');
            container.append(row);
          }
          if (row.dataset.variantId === variant.id) return;
          row.dataset.variantId = variant.id;
          const price = document.createElement('span');
          price.className = 'oz-bio-price-value';
          price.textContent = variant.priceText;
          price.setAttribute('aria-label', `${this.data.salePriceLabel} ${variant.priceText}`);
          row.replaceChildren(price);
          if (variant.compareAtPrice > variant.price) {
            const compare = document.createElement('del');
            compare.className = 'oz-bio-price-compare';
            compare.textContent = variant.compareAtPriceText;
            compare.setAttribute('aria-label', `${this.data.regularPriceLabel} ${variant.compareAtPriceText}`);
            const discount = document.createElement('span');
            discount.className = 'oz-bio-price-discount';
            discount.textContent = `−${Math.round((1 - variant.price / variant.compareAtPrice) * 100)}%`;
            row.append(compare, discount);
          }
        });
        const sticky = this.section.querySelector(`sticky-add-to-cart[data-product-id="${this.dataset.productId}"]`);
        if (sticky) {
          sticky.dataset.currentVariantId = variant.id;
          sticky.dataset.variantAvailable = String(variant.available);
          const title = sticky.querySelector('.sticky-add-to-cart__variant');
          if (title && title.textContent !== variant.title) title.textContent = variant.title;
        }
        this.updatePurchaseState();
      }

      updatePurchaseState() {
        const variant = this.variants.get(this.selectedId);
        const form = this.nativeForm();
        const sticky = this.section.querySelector(`sticky-add-to-cart[data-product-id="${this.dataset.productId}"]`);
        const main = form?.querySelector('[ref="addToCartButton"]');
        const buyNow = form?.querySelector('.oz-buy-now__button');
        const disabled = Boolean(this.posting || !variant?.available);
        [main, sticky?.querySelector('[ref="addToCartButton"]'), buyNow].forEach(button => {
          if (!button) return;
          if (button.disabled !== disabled) button.disabled = disabled;
          if (this.purchaseBusy) button.setAttribute('aria-busy', 'true');
          else button.removeAttribute('aria-busy');
        });
        if (buyNow) {
          const idle = buyNow.querySelector('[data-idle]');
          const busy = buyNow.querySelector('[data-busy]');
          if (idle) idle.hidden = Boolean(this.purchaseBusy);
          if (busy) busy.hidden = !this.purchaseBusy;
        }
      }

      syncForm(id) {
        const variant = this.variants.get(id);
        const input = this.nativeForm()?.querySelector('input[name="id"]');
        if (variant && input) input.value = variant.id;
      }

      async submitExactVariant(checkout, button) {
        const id = this.inputs.find(input => input.checked)?.value || this.selectedId;
        const variant = this.variants.get(id);
        if (this.posting || !variant?.available) return;
        this.posting = true;
        this.purchaseBusy = true;
        this.updatePurchaseState();
        const status = this.section.querySelector('.oz-buy-now__status');
        if (status) status.hidden = true;
        const request = new AbortController();
        const timeout = setTimeout(() => request.abort(), 30000);
        try {
          await addNativeCartItems({
            source: this,
            items: [{ id: variant.id, quantity: 1 }],
            cartAddUrl: this.data.cartAddUrl,
            cartUrl: this.data.cartUrl,
            productId: this.dataset.productId,
            checkout,
            signal: request.signal
          });
          if (checkout) {
            window.location.assign(this.data.checkoutUrl);
          } else {
            this.posting = false;
            this.purchaseBusy = false;
            this.refreshSelectedPrice();
          }
        } catch {
          this.purchaseBusy = false;
          this.updatePurchaseState();
          if (status) {
            status.hidden = false;
            const error = status.querySelector('[data-error]');
            const uncertain = status.querySelector('[data-timeout]');
            if (error) error.hidden = true;
            if (uncertain) uncertain.hidden = false;
          }
        } finally {
          clearTimeout(timeout);
        }
      }

      selectVariant(id) {
        const variant = this.variants.get(id);
        if (!variant?.available) return;
        this.selectCard(id);
        this.syncForm(id);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', id);
        history.replaceState(history.state, '', url);
        const picker = this.nativePicker();
        const radio = Array.from(picker?.querySelectorAll('input[type="radio"]') || []).find(input =>
          input.dataset.variantId === id || input.value === variant.options[0]
        );
        const option = Array.from(picker?.querySelectorAll('select option') || []).find(input =>
          input.dataset.variantId === id || input.value === variant.options[0]
        );
        if (!radio && !option) return;
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          const select = option.closest('select');
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }
})().catch(error => console.error('Ozoric purchase controls could not initialize', error));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ozoric-deferred-videos"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ozoric-deferred-videos')) {
    class OzoricDeferredVideos extends HTMLElement {
      connectedCallback() {
        this.videos = Array.from(this.querySelectorAll('video[data-oz-autoplay]'));
        this.visibleVideos = new Set();
        this.controller = new AbortController();
        if (!this.videos.length) return;

        const loadVideo = (video) => {
          if (video.dataset.ozVideoLoaded) return;
          video.dataset.ozVideoLoaded = 'true';
          for (const source of video.querySelectorAll('source[data-src]')) {
            source.src = source.dataset.src;
            delete source.dataset.src;
          }
          if (video.dataset.src) {
            video.src = video.dataset.src;
            delete video.dataset.src;
          }
          video.preload = 'metadata';
          video.load();
        };

        const playVideo = (video) => {
          if (document.hidden) return;
          loadVideo(video);
          video.muted = true;
          const playback = video.play();
          playback?.catch(() => {});
        };

        if (!('IntersectionObserver' in window)) {
          this.videos.forEach((video) => {
            this.visibleVideos.add(video);
            playVideo(video);
          });
        } else {
          this.preloadObserver = new IntersectionObserver((entries) => {
            for (const entry of entries) {
              if (!entry.isIntersecting) continue;
              loadVideo(entry.target);
              this.preloadObserver.unobserve(entry.target);
            }
          }, { rootMargin: '300px 0px' });

          this.playObserver = new IntersectionObserver((entries) => {
            for (const entry of entries) {
              if (entry.isIntersecting) {
                this.visibleVideos.add(entry.target);
                playVideo(entry.target);
              } else {
                this.visibleVideos.delete(entry.target);
                entry.target.pause();
              }
            }
          }, { threshold: 0.01 });

          this.videos.forEach((video) => {
            this.preloadObserver.observe(video);
            this.playObserver.observe(video);
          });
        }

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.videos.forEach((video) => video.pause());
          else this.visibleVideos.forEach(playVideo);
        }, { signal: this.controller.signal });
      }

      disconnectedCallback() {
        this.preloadObserver?.disconnect();
        this.playObserver?.disconnect();
        this.controller?.abort();
        this.videos?.forEach((video) => video.pause());
        this.visibleVideos?.clear();
      }
    }
    customElements.define('ozoric-deferred-videos', OzoricDeferredVideos);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ozoric-native-bundles"] && !Shopify.designMode) return;
  try {
    ;(async () => {
  const [{ StandardEvents }, { addNativeCartItems }] = await Promise.all([
    import('@shopify/events'),
    import('@theme/ozoric-cart-actions')
  ]);
if (!customElements.get('ozoric-native-bundles')) {
  customElements.define('ozoric-native-bundles', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true, signal: this.controller.signal });
      } else queueMicrotask(() => this.initialize());
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.visibilityObserver?.disconnect();
      this.footerObserver?.disconnect();
      clearTimeout(this.timeout);
      if (this.section?.dataset.ozNativeBundlesReady === this.id) {
        this.section.removeAttribute('data-oz-native-bundles-ready');
        this.section.querySelector('sticky-add-to-cart [ref="addToCartButton"]')?.setAttribute('on:click', '/handleAddToCartClick');
      }
    }
    initialize() {
      if (!this.isConnected) return;
      try { this.data = JSON.parse(this.querySelector('script[type="application/json"]').textContent); } catch { return; }
      this.section = this.closest('.shopify-section');
      if (!this.section || !this.data.variants?.length) return;
      this.variants = this.data.variants;
      this.variantMap = new Map(this.variants.map(variant => [variant.id, variant]));
      const selected = this.variantMap.get(this.data.selectedId) || this.variants.find(variant => variant.available) || this.variants[0];
      this.unitOptions = Array.from({ length: 3 }, () => [...selected.options]);
      this.count = 1;
      this.pending = false;
      this.uncertain = false;
      try { this.currency = new Intl.NumberFormat(this.data.locale, { style: 'currency', currency: this.data.currency, currencyDisplay: 'symbol' }); } catch { return; }
      const signal = this.controller.signal;
      this.addEventListener('change', event => this.handleChange(event), { signal });
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-bundle-action]');
        if (button && this.contains(button)) this.submit(button.dataset.bundleAction === 'checkout');
      }, { signal });
      this.section.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || this.contains(button)) return;
        const sticky = button.closest('sticky-add-to-cart');
        const component = button.closest('product-form-component');
        const isSticky = sticky?.dataset.productId === this.dataset.productId;
        const isNative = component?.dataset.productId === this.dataset.productId && button.matches('[ref="addToCartButton"], .oz-buy-now__button');
        if (!isSticky && !isNative) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        this.submit(button.matches('.oz-buy-now__button'));
      }, { capture: true, signal });
      this.section.addEventListener(StandardEvents.productSelect, event => {
        event.promise?.then(() => requestAnimationFrame(() => this.refreshSticky())).catch(() => {});
      }, { signal });
      window.addEventListener('pageshow', event => {
        if (!event.persisted) return;
        this.pending = false;
        this.uncertain = false;
        this.showStatus('');
        this.refresh();
      }, { signal });
      this.section.dataset.ozNativeBundlesReady = this.id;
      this.hidden = false;
      this.visibilityObserver = new IntersectionObserver(() => {
        this.passed = this.querySelector('[data-bundle-actions]').getBoundingClientRect().bottom < 0;
        this.refreshStickyVisibility();
      });
      this.visibilityObserver.observe(this.querySelector('[data-bundle-actions]'));
      const footer = document.querySelector('footer, [class*="footer-group"]');
      if (footer) {
        this.footerObserver = new IntersectionObserver(entries => {
          this.footerVisible = entries[0]?.isIntersecting;
          this.refreshStickyVisibility();
        });
        this.footerObserver.observe(footer);
      }
      this.refresh();
    }
    money(cents) { return this.currency.format(cents / 100); }
    selectedVariant(unit) {
      return this.variants.find(variant => variant.options.every((value, index) => value === this.unitOptions[unit][index]));
    }
    totals(count) {
      const percent = this.data.percentages[count - 1] || 0;
      let regular = 0;
      let total = 0;
      for (let unit = 0; unit < count; unit += 1) {
        const variant = this.selectedVariant(unit);
        if (!variant) return null;
        regular += variant.price;
        total += variant.price - Math.floor(variant.price * percent / 100);
      }
      return { regular, total };
    }
    selection() {
      const items = new Map();
      for (let unit = 0; unit < this.count; unit += 1) {
        const variant = this.selectedVariant(unit);
        if (!variant?.available) return null;
        const item = items.get(variant.id) || { id: variant.id, quantity: 0 };
        item.quantity += 1;
        items.set(variant.id, item);
      }
      for (const item of items.values()) {
        const variant = this.variantMap.get(item.id);
        if (variant.inventoryLimit !== null && item.quantity > variant.inventoryLimit) return null;
        if (item.quantity < variant.minimum || item.quantity % variant.increment !== 0) return null;
        if (variant.maximum > 0 && item.quantity > variant.maximum) return null;
      }
      return [...items.values()];
    }
    handleChange(event) {
      if (this.pending || this.uncertain) return;
      const target = event.target;
      if (target.matches('.oz-nb-radio')) {
        this.count = Number(target.value);
      } else if (target.matches('select[data-option-index]')) {
        const unit = Number(target.closest('[data-unit-index]').dataset.unitIndex);
        const index = Number(target.dataset.optionIndex);
        this.unitOptions[unit][index] = target.value;
        if (unit === 0) this.syncNativePicker();
      }
      this.showStatus('');
      this.refresh();
    }
    refresh() {
      this.querySelectorAll('[data-bundle-tier]').forEach(card => {
        const count = Number(card.dataset.bundleTier);
        const active = count === this.count;
        card.classList.toggle('is-selected', active);
        const radio = card.querySelector('.oz-nb-radio');
        radio.checked = active;
        radio.disabled = this.pending || this.uncertain;
        radio.setAttribute('aria-expanded', String(active));
        card.querySelector('.oz-nb-options').hidden = !active;
        card.querySelectorAll('select[data-option-index]').forEach(select => {
          const unit = Number(select.closest('[data-unit-index]').dataset.unitIndex);
          const index = Number(select.dataset.optionIndex);
          select.value = this.unitOptions[unit][index];
          select.disabled = !active || this.pending || this.uncertain;
          Array.from(select.options).forEach(option => {
            option.disabled = !this.variants.some(variant => variant.available && variant.options[index] === option.value);
          });
        });
        const totals = this.totals(count);
        card.querySelector('[data-tier-total]').textContent = totals ? this.money(totals.total) : '—';
        const compare = card.querySelector('[data-tier-compare]');
        compare.hidden = !totals || totals.total >= totals.regular;
        compare.textContent = totals ? this.money(totals.regular) : '';
        card.querySelector('[data-tier-per-pair]').textContent = totals ? `${this.money(totals.total / count)} ${this.data.labels.perPair}` : '';
      });
      const totals = this.totals(this.count);
      this.querySelector('[data-bundle-total]').textContent = totals ? this.money(totals.total) : '—';
      const disabled = this.pending || this.uncertain || !this.selection();
      this.querySelectorAll('[data-bundle-action]').forEach(button => {
        button.disabled = disabled;
        button.setAttribute('aria-busy', String(this.pending));
        const label = button.querySelector('[data-bundle-button-label]');
        label.textContent = this.pending ? this.data.labels.loading : (button.dataset.bundleAction === 'checkout' ? this.data.labels.buy : this.data.labels.add);
      });
      if (!this.pending && !this.uncertain && !this.selection()) this.showStatus(this.data.labels.unavailable);
      this.refreshSticky();
    }
    refreshSticky() {
      const sticky = this.section.querySelector(`sticky-add-to-cart[data-product-id="${this.dataset.productId}"]`);
      if (!sticky) return;
      const variant = this.selectedVariant(0);
      const valid = Boolean(this.selection());
      sticky.dataset.variantAvailable = String(valid);
      sticky.dataset.currentVariantId = variant?.id || '';
      const button = sticky.querySelector('[ref="addToCartButton"]');
      if (button) {
        button.removeAttribute('on:click');
        button.disabled = this.pending || this.uncertain || !valid;
      }
      const quantity = sticky.querySelector('[ref="quantityNumber"]');
      if (quantity) quantity.textContent = String(this.count);
      const quantityDisplay = sticky.querySelector('[ref="quantityDisplay"]');
      if (quantityDisplay) quantityDisplay.style.display = this.count > 1 ? 'inline' : 'none';
      const price = sticky.querySelector('.sticky-add-to-cart__price');
      const totals = this.totals(this.count);
      if (price && totals) price.textContent = this.money(totals.total);
      this.refreshStickyVisibility();
    }
    refreshStickyVisibility() {
      const bar = this.section.querySelector('sticky-add-to-cart [ref="stickyBar"]');
      if (bar) bar.dataset.stuck = String(Boolean(this.passed && !this.footerVisible));
    }
    syncNativePicker() {
      const variant = this.selectedVariant(0);
      const picker = this.section.querySelector(`variant-picker[data-product-id="${this.dataset.productId}"]`);
      if (!variant || !picker) return;
      let trigger;
      picker.querySelectorAll('.variant-option').forEach((group, index) => {
        const radios = Array.from(group.querySelectorAll('input[type="radio"]'));
        const radio = radios.find(input => input.value === variant.options[index]);
        if (radio) {
          radios.forEach(input => { input.checked = input === radio; });
          trigger = radio;
        }
        const select = group.querySelector('select');
        if (select && Array.from(select.options).some(option => option.value === variant.options[index])) {
          select.value = variant.options[index];
          trigger = select;
        }
      });
      trigger?.dispatchEvent(new Event('change', { bubbles: true }));
    }
    showStatus(message) {
      const status = this.querySelector('.oz-nb-status');
      status.hidden = !message;
      status.querySelector('[data-status-text]').textContent = message;
    }
    async submit(checkout) {
      if (this.pending || this.uncertain) return;
      const items = this.selection();
      if (!items) {
        this.showStatus(this.data.labels.unavailable);
        this.querySelector('.oz-nb-status').focus();
        return;
      }
      this.pending = true;
      this.showStatus('');
      this.refresh();
      const request = new AbortController();
      this.timeout = setTimeout(() => request.abort(), 30000);
      try {
        await addNativeCartItems({
          source: this,
          items,
          cartAddUrl: this.data.cartAddUrl,
          cartUrl: this.data.cartUrl,
          productId: this.dataset.productId,
          checkout,
          signal: request.signal
        });
        if (checkout) {
          window.location.assign(this.data.checkoutUrl);
        } else {
          this.pending = false;
          this.refresh();
        }
      } catch {
        this.pending = false;
        this.uncertain = true;
        this.showStatus(this.data.labels.uncertain);
        this.refresh();
        this.querySelector('.oz-nb-status').focus();
      } finally {
        clearTimeout(this.timeout);
      }
    }
  });
}
})().catch(error => console.error('Ozoric purchase controls could not initialize', error));
  } catch(e) { console.error(e); }
})();

})();
